/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap/ScrollSmoother";
// gsap.registerPlugin(ScrollTrigger,ScrollSmoother);
import imagesLoaded from 'imagesloaded';

import { featuredSlider } from './modules/featuredSlider';
import { iconSlider } from './modules/iconSlider';
import { moreBlogsSlider } from './modules/moreBlogsSlider';
import { customCardSlider } from './modules/customCardSlider';
import { brandsSlider } from './modules/brandsSlider';
import { imageCarousel } from './modules/imageCarousel';

// // Check URL for parameters
(function () {
  const UTM_STORAGE_KEY = "utmParams";
  const UTM_EXPIRY_DAYS = 30;

  // Get stored UTM params, checking for expiry.
  function getStoredUTMParams() {
    const raw = localStorage.getItem(UTM_STORAGE_KEY);
    if (!raw) return null;
    try {
      const data = JSON.parse(raw);
      const now = Date.now();
      if (data.expires && now > data.expires) {
        localStorage.removeItem(UTM_STORAGE_KEY);
        return null;
      }
      return data.params;
    } catch (e) {
      // Handle legacy sessionStorage format or corrupt data.
      localStorage.removeItem(UTM_STORAGE_KEY);
      return null;
    }
  }

  // Save UTM params with a 30-day expiry timestamp.
  function setStoredUTMParams(params) {
    const data = {
      params: params,
      expires: Date.now() + (UTM_EXPIRY_DAYS * 24 * 60 * 60 * 1000)
    };
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(data));
  }

  // Save UTM parameters from the landing URL.
  // If the current URL has UTM params, always overwrite stored values
  // (new campaign link should replace old tracking).
  function saveUTMParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = new URLSearchParams();
    urlParams.forEach((value, key) => {
      if (key.startsWith("utm_")) {
        utmParams.set(key, value);
      }
    });
    if ([...utmParams].length > 0) {
      setStoredUTMParams(utmParams.toString());
    }
  }

  // Build the combined query string with feedId first, then UTM parameters.
  function getCombinedQueryString() {
    const stored = getStoredUTMParams();
    // Ensure feedId is the first parameter.
    if (stored && stored.length > 0) {
      return "feedId=256801&" + stored;
    }
    return "feedId=256801&utm_source=NestleCareers";
  }

  // Update a single link's href using the combined query string.
  function updateLink(link) {
    if (!link || !link.href) return;
    try {
      const combinedQuery = getCombinedQueryString();
      const url = new URL(link.href, window.location.origin);
      // Overwrite the entire query string.
      url.search = combinedQuery;
      link.href = url.toString();
    } catch (e) {
      console.error("Error updating link:", link, e);
    }
  }

  // Update all links matching the selector.
  function updateAllLinks() {
    const links = document.querySelectorAll('.results__resultLink');
    links.forEach(link => updateLink(link));
  }

  // Intercept clicks on any link with the selector, in case they haven't been updated yet.
  document.addEventListener("click", function (e) {
    const link = e.target.closest('.results__resultLink');
    if (link) {
      updateLink(link);
    }
  });

  // Save UTM parameters and update links on DOMContentLoaded.
  document.addEventListener("DOMContentLoaded", function () {
    saveUTMParams();
    updateAllLinks();
  });

  // Use a MutationObserver to update newly added links (e.g. via pagination).
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.matches && node.matches('.results__resultLink')) {
            updateLink(node);
          }
          const descendants = node.querySelectorAll('.results__resultLink');
          descendants.forEach(descendant => updateLink(descendant));
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// Sliders must NOT wait on imagesLoaded(body): GTM injects third-party
// tracking pixels as <img> tags, and a hung pixel (e.g. jelly-v6.mdhv.io
// on some corporate networks) kept every carousel invisible until the
// pixel timed out minutes later. Each slider re-measures its own images
// itself (flickity-imagesloaded / a scoped imagesLoaded call).
var featuredSliderExists = document.querySelector('.featured-articles-slider');
if (featuredSliderExists) {
  featuredSlider();
}

var iconSliderExists = document.querySelector('.iconSlider');
if (iconSliderExists) {
  iconSlider();
}

var moreBlogsExists = document.querySelector('.more-blogs-slider');
if (moreBlogsExists) {
  moreBlogsSlider();
}

// var customCardSliderExists = document.querySelector('.customCardSlider');
// if (customCardSliderExists) {
//   customCardSlider();
// }

var brandsSliderExists = document.querySelector('.homeBrands__panels');
if (brandsSliderExists) {
  brandsSlider();
}

var imageCarouselExists = document.querySelector('.image-carousel__track');
if (imageCarouselExists) {
  imageCarousel();
}

imagesLoaded(document.querySelector('body'), function (instance) {
  var onMap = document.querySelector('#nc-location-map');
  if (onMap) {
    const mapFilterString = window.location.search;
    const urlParams = new URLSearchParams(mapFilterString);
    const mapFilter = urlParams.get('map-filter');
    // alert(mapFilter);
    if (mapFilter == "retail") {
      // alert('testing');
      setTimeout(() => {
        $('.map-key__item-container:nth-of-type(5)').trigger('click');
      }, 2000);
    }
  }
});


// Don't load on mobile
function is_touch_enabled() {
  return ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0);
}

import { stickyJobSearch } from './modules/stickyJobSearch';
// The rebuilt job search page pins its search bar with CSS sticky, so the
// width-juggling module only runs on the pages still using the old markup.
var stickyJobSearchExists = document.querySelector('.block-views-exposed-filter-blockjob-search-page-1')
  && !document.querySelector('.jobSearchBar');

if (stickyJobSearchExists) {
  stickyJobSearch();
}

// Mobile vs. Desktop controls
if (!is_touch_enabled()) {



} else {
  $('body').addClass('touch');
}

// Load 'em
import { mobileNav } from './modules/mobileNav';
mobileNav();

// Refire stuff on window resize
var timeout = false, // holder for timeout id
  delay = 250; // delay after event is "complete" to run callback

// window.resize event listener
window.addEventListener('resize', function () {
  // clear the timeout
  clearTimeout(timeout);
  // start timing for event "completion"
  timeout = setTimeout(function () {
    // ScrollTrigger.refresh();
  }, delay);
});

$('.filters__toggle').hide();

// Original "Job Search Filters" button (legacy - for non-main search pages)
$('.filters__button').on('click tap', function () {
  $('.filters__toggle').addClass('show');
  $(this).hide();
  $('.filters__keyword-mobile').hide(); // Hide the mobile keyword section when showing all filters
});

// New "View All Filters" / "Close All Filters" button for mobile
$('.filters__view-all-button').on('click tap', function () {
  var $button = $(this);
  var isOpen = $('.filters__toggle').hasClass('show');

  if (isOpen) {
    // Currently open - close it
    $('.filters__toggle').removeClass('show');
    $('.filters__keyword-mobile').show(); // Show the mobile keyword section again
    $('.filters__toggle .js-form-item-keyword').removeClass('mobile-show'); // Hide keyword in toggle
    $('.page-view-job-search .block-views-exposed-filter-blockjob-search-page-1').removeClass('filters-expanded');
    $button.text('View All Filters');
  } else {
    // Currently closed - open it
    $('.filters__toggle').addClass('show');
    $('.filters__keyword-mobile').hide(); // Hide the entire mobile keyword section
    $('.filters__button').hide(); // Hide the legacy button
    $('.page-view-job-search .block-views-exposed-filter-blockjob-search-page-1').addClass('filters-expanded');
    $button.text('Close All Filters');

    // Show the keyword field in the toggle since mobile section is now hidden
    setTimeout(function() {
      $('.filters__toggle .js-form-item-keyword').addClass('mobile-show');

      // Transfer any pills from mobile field to toggle field
      var mobilePills = $('.filters__keyword-mobile .keyword-pills .pill');
      var togglePillsContainer = $('.filters__toggle .keyword-pills');

      if (mobilePills.length && togglePillsContainer.length) {
        mobilePills.each(function() {
          var pillValue = $(this).data('val');
          var pillText = $(this).text().replace('×', '');
          // Add pill to toggle field if it doesn't already exist
          if (!togglePillsContainer.find('.pill[data-val="' + pillValue + '"]').length) {
            var newPill = $(this).clone();
            togglePillsContainer.append(newPill);
          }
        });
      }

      // Initialize mobile auto-submit for newly visible company and job type filters
      if (window.matchMedia('(max-width: 959px)').matches) {
        $('.filters__toggle select[name="company[]"], .filters__toggle select[name="career_type[]"]')
          .off('change.mobileAutoSubmit') // Remove any existing handlers
          .on('change.mobileAutoSubmit', function() {
            $('#edit-submit-job-search--2').trigger('click');
          });

        // Handle dropdown toggle for company and job type filters (direct child label only)
        $('.filters__toggle .js-form-item-company > label, .filters__toggle .js-form-item-career-type > label')
          .off('click.mobileDropdown')
          .on('click.mobileDropdown', function(e) {
            e.preventDefault();
            var $formItem = $(this).closest('.js-form-item');
            $formItem.toggleClass('open');
          });
      }
    }, 50);
  }
});

$('.filters__close').on('click tap', function () {
  $('.filters__toggle').removeClass('show');
  $('.filters__button').show();
  $('.filters__keyword-mobile').show(); // Show the mobile keyword section again

  // Hide the keyword field in toggle since mobile section is now visible
  $('.filters__toggle .js-form-item-keyword').removeClass('mobile-show');

  // Remove filters expanded class
  $('.page-view-job-search .block-views-exposed-filter-blockjob-search-page-1').removeClass('filters-expanded');

  // Reset the view all filters button text
  $('.filters__view-all-button').text('View All Filters');

  // Clean up mobile filter event handlers
  $('.filters__toggle select[name="company[]"], .filters__toggle select[name="career_type[]"]')
    .off('change.mobileAutoSubmit');

  // Clean up mobile dropdown click handlers
  $('.filters__toggle .js-form-item-company label, .filters__toggle .js-form-item-career-type label')
    .off('click.mobileDropdown');

  // Remove open class from form items
  $('.filters__toggle .js-form-item-company, .filters__toggle .js-form-item-career-type')
    .removeClass('open');
});

$('.filters__search').on('click tap', function () {
  // Only scroll on main search page, not inline feeds
  if (window.location.pathname === '/job-search') {
    $('body,html').animate({
      scrollTop: $('.results').offset().top
    }, 0);
  }
});

const body = document.body;
const triggerMenu = document.querySelector(".siteHeader");
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
let lastScroll = 0;

// Sticky Search
// $('.siteHeader__jobSearch').on('click tap', function(e) {
//   e.preventDefault();
//   $('.stickySearch').addClass('open');
//   $("#keyword").focus();
//   $(this).addClass('hiding');
//   $('.siteHeader__closeJobSearch').addClass('showing');

//   if ($(window).innerWidth() < 960 ) {
//     $('.filters__toggle').show();
//     $('.filters__button').hide();
//   }
// });

// $('.siteHeader__closeJobSearch').on('click tap', function() {
//   $('.stickySearch').removeClass('open');
//   $(this).removeClass('showing');
//   $('.siteHeader__jobSearch').removeClass('hiding');

//   if ($(window).innerWidth() < 960 ) {
//     $('.filters__toggle').hide();
//     $('.filters__button').show();
//   }
// });

// Site Footer Social
if ($(window).innerWidth() < 960) {
  $('.siteFooter__socialLI').on('click tap', function () {
    $('.siteFooter__socialLI').removeClass('active');
    $(this).addClass('active');
  });

  $(document).on("click tap", function (event) {
    // If the target is not the container or a child of the container, then process
    // the click event for outside of the container.
    if ($(event.target).closest(".siteFooter__socialLI").length === 0) {
      $('.siteFooter__socialLI').removeClass('active');
    }
  });
}

window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 0) {
    body.classList.remove(scrollUp);
    return;
  }

  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
  } else if (
    currentScroll < lastScroll &&
    body.classList.contains(scrollDown)
  ) {
    // up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
  }
  lastScroll = currentScroll;
});

$('.filters__input--select').not('.filters__checkboxList').on('click tap', function () {
  $(this).toggleClass('open');
  $(this).closest('.filters__filter').addClass('open');
  $(this).find('.filters__checkboxList').toggle();
});

// Toggle click hack
$('a[href="#show-statement"]').on('click tap', function (e) {
  e.preventDefault();
  $(this).toggleClass('open');
  $('.toggle').slideToggle();
});


// Card-link: make entire card clickable via the CTA link inside
$('.card-link').on('click', function (e) {
  // Don't hijack clicks on the actual link or interactive elements
  if ($(e.target).closest('a, button, input, select, textarea').length) return;
  var $link = $(this).find('.dsu_btn a').first();
  if (!$link.length) return;
  var href = $link.attr('href');
  if (!href) return;
  if ($link.attr('target') === '_blank') {
    window.open(href, '_blank');
  } else {
    window.location.href = href;
  }
});

// // Class applications for styling
$(".field__item").has(".pageHero").addClass("pageHero");
$(".field__item").has(".pageHero--purinaBlog").addClass("pageHero--purinaBlog");
$(".field__item").has(".noPaddingTop").addClass("noPaddingTop");
$(".field__item").has(".noPaddingBottom").addClass("noPaddingBottom");
$(".field__item").has(".pageIntro").addClass("pageIntroContainer");
$(".field__item").has(".lightBackground").addClass("lightBackground");
$(".field__item").has(".redBackground").addClass("redBackground");
$(".field__item").has(".lightBackground--gerberYellow").addClass("lightBackground--gerberYellow");
$(".field__item").has(".lightBackground--nhsGreen").addClass("lightBackground--nhsGreen");
$(".field__item").has(".blueBackground").addClass("blueBackground");


// Olivia Stuff
// Function to open Olivia chat
function openOliviaChat() {
  try {
    // Find the Olivia chat widget launcher
    const launcher = document.querySelector('[id*="chat-widget"]');
    if (launcher) {
      // Use a slight delay and multiple event types to ensure it works
      setTimeout(() => {
        // Create realistic click event with coordinates
        const event = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true,
          clientX: launcher.getBoundingClientRect().left + 10,
          clientY: launcher.getBoundingClientRect().top + 10
        });

        // Try multiple interaction methods
        launcher.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
        launcher.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
        launcher.dispatchEvent(event);
        launcher.click();

        // Also trigger clicks on child elements
        const children = launcher.querySelectorAll('*');
        children.forEach(child => {
          child.click();
        });

      }, 100);

      // Also try immediate methods
      launcher.focus();
      launcher.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', bubbles: true }));

    } else {
      console.warn('Olivia chat launcher not found');
    }
  } catch (error) {
    console.error('Error opening Olivia chat:', error);
  }
}

// Add click event listeners to the links. The front page has two triggers
// (alert banner + homeOlivia CTA), so match by class as well as id.
document.querySelectorAll('.openOliviaChat, #openOliviaChat').forEach(function (element) {
  element.addEventListener('click', function(event) {
    event.preventDefault();
    openOliviaChat();
  });
});

const oliviaInfoElement = document.querySelector('.oliviaInfo .dsu_btn a');
if (oliviaInfoElement) {
  oliviaInfoElement.addEventListener('click', function (event) {
    event.preventDefault();
    openOliviaChat();
  });
}

import { siteCookieControls } from './modules/cookies';
document.addEventListener('DOMContentLoaded', function() {
  siteCookieControls();
});

import { initScrollAnimations } from './modules/scrollAnimations';
initScrollAnimations();

import { initCountUp } from './modules/countUp';
initCountUp();

// Search placeholders, as on production: every keyword and location field,
// the inline OpCo feed's included, reads "Search jobs by title or
// keyword(s)" / "Search jobs by location", whatever the view is configured
// with. Runs as a behaviour too, so a form re-rendered by Views AJAX gets the
// same text.
(function () {
  const fields = [
    { selector: 'input[name="keyword"]', full: 'Search jobs by title or keyword(s)' },
    { selector: 'input[name="location"]', full: 'Search jobs by location' },
  ];

  function update(context) {
    const root = context && context.querySelectorAll ? context : document;
    fields.forEach(function (f) {
      root.querySelectorAll(f.selector).forEach(function (el) {
        el.placeholder = f.full;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { update(document); });
  if (window.Drupal) {
    window.Drupal.behaviors.searchPlaceholders = { attach: update };
  }
})();

